import React, { useCallback, useEffect, useState } from 'react';
import {
  BadgesDescription,
  BadgesHeader
} from './RewardsBadgesBlockStyle';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import ProgressBar from '../UI/ProgressBarBadges/Desktop/ProgressBar';
import ProgressBarMobile from '../UI/ProgressBarBadges/Mobile/ProgressBarMobile';
import Fade from 'react-reveal/Fade';

interface IRewardBadgeBlock {
  context?: IContent
}

let externalBadge: number = 0;
const RewardsBadgesBlock = ({ context }: IRewardBadgeBlock) => {
  const [previousLoadPercentage, setPreviousLoadPercentage] = useState(0);
  const [newLoadPercentage, setNewLoadPercentage] = useState(0);
  const [currentBadge, setCurrentBadge] = useState(0);

  useEffect(() => {
    //After animation, checks if the current badge has changed
    badgeClick(context.rewardBadge.badge[currentBadge].loadPercentage, currentBadge, false);
    setTimeout(function(currentBadge) {
      if (currentBadge === externalBadge && externalBadge < context.rewardBadge.badge.length - 1) {
        externalBadge++;
        setCurrentBadge(externalBadge);
      } else if (currentBadge === externalBadge && externalBadge >= context.rewardBadge.badge.length - 1) {
        externalBadge = 0;
        setCurrentBadge(externalBadge);
      }
    }, 2000,currentBadge);
  }, [currentBadge,setCurrentBadge]);

  const badgeClick = useCallback((loadPercentage: string, index?: number, animationPass?: boolean) => {
    //Cancels animation an resets the current index to the badge clicked
    if (animationPass) {
      externalBadge = index;
      setCurrentBadge(index);
    } else {
      setPreviousLoadPercentage(parseFloat(context.rewardBadge.badge[currentBadge].loadPercentage));
      setNewLoadPercentage(parseFloat(context.rewardBadge.badge[index].loadPercentage));
    }
  }, [previousLoadPercentage, newLoadPercentage, setPreviousLoadPercentage, setNewLoadPercentage]);

  return (
    <section>
        <BadgesHeader dangerouslySetInnerHTML={{ __html: context.rewardBadge.title }} />
        <BadgesDescription>{context.rewardBadge.description}</BadgesDescription>
        <ProgressBar previousLoadPercentage={previousLoadPercentage} newLoadPercentage={newLoadPercentage}
                     currentBadge={currentBadge} badgeClick={badgeClick} />
        <ProgressBarMobile previousLoadPercentage={previousLoadPercentage} newLoadPercentage={newLoadPercentage} currentBadge={currentBadge} badgeClick={badgeClick} />
    </section>
  );
};

export default withContent(RewardsBadgesBlock);